import { useEffect, useState } from "react";

import { listProfissionalFilterOptions } from "@/modules/recursos";
import type {
  ProfissionalFilterOptionsState,
  ProfissionalRemoteFilterColumn,
} from "@/modules/recursos";

const NO_OPTIONS: ProfissionalFilterOptionsState = {
  options: [],
  isLoading: true,
  hasError: false,
};

/**
 * Cada coluna filtrável (Cargo, Time) carrega suas opções do seu próprio serviço
 * (`GET .../profissionais/filtros/{coluna}`), independente da página em tela e
 * do período consultado: o usuário escolhe qualquer valor existente, mesmo fora
 * do resultado atual. As opções são lidas uma vez por coluna.
 */
export function useProfissionalFilterOptions(
  column: ProfissionalRemoteFilterColumn,
): ProfissionalFilterOptionsState {
  const [state, setState] = useState<ProfissionalFilterOptionsState>(NO_OPTIONS);

  useEffect(() => {
    let cancelled = false;
    const controller = new AbortController();

    setState(NO_OPTIONS);

    listProfissionalFilterOptions({ column, signal: controller.signal })
      .then((options) => {
        if (cancelled) return;
        setState({ options, isLoading: false, hasError: false });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ options: [], isLoading: false, hasError: true });
      });

    return () => {
      cancelled = true;
      controller.abort();
    };
  }, [column]);

  return state;
}
